import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { array, object } from 'prop-types';
import MaterialTable from 'material-table';
import ActionBar from '../../components/ActionBar';

import classes from './NiagaraDevicesTable.module.css';

import { fetchErpStatuses } from '../../actions/architectActions';

const DesiredStatusTypes = ['servicecallstatus', 'serviceappointmentstatus'];

const ServiceStatusesTable = ({
    fetchErpStatuses,
    selectedErpAgent,
    selectedErpAgentStatuses,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [statusList, setStatusList] = useState([]);

    useEffect(() => {
        const getStatuses = async () => {
            setIsLoading(true);
            await fetchErpStatuses(selectedErpAgent.id, DesiredStatusTypes);
            setIsLoading(false);
        };
        getStatuses();
    },[selectedErpAgent]);

    useEffect(() => {
        setStatusList([...selectedErpAgentStatuses]);
    }, [selectedErpAgentStatuses]);

    const handleSearch = searchTerm => {
        if (isEmpty(searchTerm)) {
            setStatusList([...selectedErpAgentStatuses]);
        } else {
            const results = statusList.filter(status =>
                status.label.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setStatusList(results);
        }
    };

    return (
        <React.Fragment>
            <div className={classes.NiagaraDevicesTable} >
                <ActionBar
                    onSearch={handleSearch}
                />
                <MaterialTable
                    isLoading={isLoading}
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        sorting:   true,
                        toolbar:   false
                    }}
                    columns={[
                        {
                            field: 'label',
                            title: 'Status Name'
                        }
                    ]}
                    data={statusList}
                />
            </div>
        </React.Fragment>
    );
};

ServiceStatusesTable.defaultProps = {
    companyInfo:              {},
    selectedErpAgentStatuses: []
};

ServiceStatusesTable.propTypes = {
    companyInfo:              object,
    selectedErpAgentStatuses: array
};

const mapStateToProps = state => {
    return {
        companyInfo:              state.companyInfo,
        selectedErpAgent:         state.erpAgent.selectedAgent,
        selectedErpAgentStatuses: state.architect.selectedErpAgentStatuses
    };
};

const mapDispatchToProps = {
    fetchErpStatuses
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceStatusesTable);
